import React, { forwardRef, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import ReportSelectTrigger from '../../../ReportRequestForm/ReportSelectTrigger';
import { PROMO_TRIGGER_LABELLED_BY } from './consts';
import type { PromoSelectTriggerProps } from './types';

const PromoSelectTrigger = forwardRef<HTMLButtonElement, PromoSelectTriggerProps>(
  ({ dropdownId, isOpen, selectedCount, totalCount, onClick }, ref) => (
    <ReportSelectTrigger
      ref={ref}
      ariaLabelledBy={PROMO_TRIGGER_LABELLED_BY}
      count={`(${selectedCount}/${totalCount})`}
      countTestId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_COUNT}
      dropdownId={dropdownId}
      elementId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER}
      iconTestId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_ICON}
      isOpen={isOpen}
      testId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER}
      title={TEXTS.AUDIO_REPORT_PROMOS_SELECTED_TITLE}
      titleTestId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_TITLE}
      onClick={onClick}
    />
  )
);

PromoSelectTrigger.displayName = 'PromoSelectTrigger';

export default memo(PromoSelectTrigger);
